import api from "../services/api";
import { toast } from "react-toastify";
import toastError from "../errors/toastError";

const GeneralActions = async (option, props, onFinished) => {
    if (!option) return;

    try {
        let response;

        if (option === "closed") {

            const { message, reason, userId, conclusionId, selectedTickets } = props;

            await Promise.all(selectedTickets.map(async (ticket) => {
                await api.put(`/tickets/${ticket}`, {
                    status: "closed",
                    reason,
                    userId,
                    conclusionId,
                    inBatch: true,
                    sendConclusionMessage: Array.isArray(selectedTickets) && selectedTickets.length == 1 ? true : false
                });
            }));

            onFinished();
            return;
        }
        else if (option === "open") {
            const { selectedTickets } = props;
            response = await api.post(`/tickets/GeneralActions`, {
                ticketsIds: selectedTickets,
                option,
                props: { selectedTickets },
                inBatch: true
            });
            onFinished();
        } else if (option === "tag" || option === "removeTags") {
            const { selectedTickets } = props;
            response = await api.post(`/tickets/GeneralActions`, {
                ticketsIds: selectedTickets,
                option,
                props
            });
            onFinished();
        } else if (option === "setUnread") {
            const { selectedTickets } = props;
            response = await api.post(`/tickets/setUnread`, {
                ticketsIds: selectedTickets,
            });
            onFinished();
        } else {
            const { selectedTickets } = props;
            response = await api.post(`/tickets/GeneralActions`, {
                ticketsIds: selectedTickets,
                option,
                inBatch: true
            });
            onFinished();
        }
    } catch (err) {
        console.error({ err });
        const errorMessages = Array.isArray(err.response?.data?.error) ?
            err.response.data.error.map(er => er.message) :
            [err.response?.data?.error?.message || 'Erro desconhecido'];

        errorMessages.forEach(errorMessage => {
            const obj = { response: { data: { error: errorMessage } } };
            toastError(obj);
        });
    }
};

export default GeneralActions;